export default __webpack_public_path__ + "static/media/wind.59122b9e.svg";